import { useNavigate, useSearchParams } from "react-router";
import BottomSheet from "../../components/BottomSheet";
import Button, { IconButton } from "../../components/Button";
import Header from "../../components/Header";
import EditSquare from "../../components/icons/edit_square.svg?react";
import { SearchInput } from "../../components/Input";
import UpgradeDialog from "../../components/UpgradeDialog";
import { useEntitlements } from "../../hooks/useAccount";
import useToggle from "../../hooks/useToggle";
import { Limit } from "../../http/onlyclicksApi";
import Page from "../../layouts/Page";
import BikeSelect from "./BikeSelect";
import FilterableSetupList from "./FilterableSetupList";
import styles from "./SetupsPage.module.css";

const isEntitledTo = (limit: Limit): boolean => {
  return limit.usage < limit.limit;
};

const SetupsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchQuery = searchParams.get("q") ?? undefined;
  const navigate = useNavigate();
  const { data: entitlements } = useEntitlements();
  const newSetupSelection = useToggle();
  const upgradeDialog = useToggle();

  return (
    <>
      <Header>
        <BikeSelect />
        <div className={styles.newSetup}>
          <IconButton
            glyph={EditSquare}
            buttonProps={{
              disabled: entitlements === undefined,
              onClick: () => {
                isEntitledTo(entitlements!.setups)
                  ? newSetupSelection.open()
                  : upgradeDialog.open();
              },
            }}
          />
        </div>
      </Header>
      <Page>
        <div className={styles.searchInput}>
          <SearchInput
            placeholder="Search for a setup"
            value={searchQuery}
            onChange={(v) => {
              setSearchParams({ q: v });
            }}
          />
        </div>
        <FilterableSetupList />
      </Page>
      <BottomSheet
        isOpen={newSetupSelection.isOpen}
        onClose={newSetupSelection.close}
      >
        <p>
          Choose <b>Create new setup</b> to start from scratch and fine-tune
          every detail to your preferences. If you already have a setup you
          like, use <b>Clone existing setup</b> to duplicate it and make
          adjustments without starting over.
        </p>
        <div className={styles.actionButtons}>
          <Button
            type="accent"
            fullWidth={true}
            buttonProps={{
              onClick: () => {
                navigate("/setups/new");
              },
            }}
          >
            Create new setup
          </Button>
          <Button
            type="accent_secondary"
            fullWidth={true}
            buttonProps={{
              onClick: () => {
                navigate("/setups/clone");
              },
            }}
          >
            Clone existing setup
          </Button>
        </div>
      </BottomSheet>
      <UpgradeDialog
        open={upgradeDialog.isOpen}
        onClose={upgradeDialog.close}
      />
    </>
  );
};

export default SetupsPage;
